export default __webpack_public_path__ + "static/media/success-request.8d0a35b9.svg";